import { z } from "zod";
import { getIdSchema, ID, makeIdGenerator } from "../utils";
import { accountIdSchema } from "./accountSchema";
import { scaleIdSchema } from "./scaleSchema";
import { scaleReportIdSchema } from "./scaleReportSchema";

export const scaleCalibrationIdPrefix = "scl_";
export type ScaleCalibrationId = ID<typeof scaleCalibrationIdPrefix>;
export const generateScaleCalibrationId = makeIdGenerator(
  scaleCalibrationIdPrefix,
);
export const scaleCalibrationIdSchema = getIdSchema(
  scaleCalibrationIdPrefix,
  "ScaleCalibrationId",
);

export const scaleCalibrationSchema = z
  .object({
    id: scaleCalibrationIdSchema,
    accountId: accountIdSchema,
    scaleId: scaleIdSchema,
    time: z.coerce.date(),
    reading1Id: scaleReportIdSchema,
    reading1Time: z.coerce.date(),
    reading1KnownWeight: z.number(),
    reading2Id: scaleReportIdSchema.nullable(),
    reading2Time: z.coerce.date().nullable(),
    reading2KnownWeight: z.number().nullable(),
    slope: z.number().nullable(),
    offset: z.number(),
    targetWeight: z.number().nullable(),
  })
  .meta({ id: "ScaleCalibration" });

export type ScaleCalibration = z.infer<typeof scaleCalibrationSchema>;
